import { Component, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { TOAST_TYPE } from '../../../../app/constants/Tpiq.constants';
import {Session} from "../../../services/Session";
import { TodoServices } from '../../../services/todos.service';
import { TpFirmTodoService } from '../../../../app/tpiq-services/tp-firm-todo.service';
import { LoadingService } from '../../../services/LoadingService';
import { CommonModule } from '@angular/common';
import {NewPostComponent} from "../../../posts/new-post/new-post.component";
import {PostWallComponent} from "../../../posts/post-wall/post-wall.component"
declare let _: any;

@Component({
  selector: 'app-drawer',
  standalone: true,
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'],
   imports: [
    CommonModule,
    NewPostComponent,
    PostWallComponent
  ]
})
export class DrawerComponent {
 
  user: any;
  org: any;
  currentTodoId: any;
  isStatusDone: boolean = false;
  currentTodo: any;
  currentPost: any;
  showPost: boolean;
  attachments: Array<any> = [];
  toastService: any;
  userId: string;
  channelId: any;
  channelType: any;
  type: any;
  loader:boolean=false;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  channelName: any;
  constructor(private router: Router,
     private _route: ActivatedRoute,
     private clientTodoService: TodoServices,
     private todoService: TpFirmTodoService,
     private loadingService: LoadingService,
  ) {
   
  }

  closeDrawer() {
    this.router.navigate([{ outlets: { popup: null } }]); 
  }

  _init() {
    this.org = Session.getOrg();
            this.userId = Session.getUser().id;
            this.user = Session.getUser('delegatedFrom').id;
            this.getTodo();
  }

  ngOnInit(): void {

    this._route.params.pipe(takeUntil(this.destroy$))
          .subscribe(params => {
            this.currentTodoId = params.todoId;
              if (params.channelId) {
                  this.channelId = params.channelId;
                  this.channelType = params.channelType;       
                  this.channelName = params.channelName ? params.channelName : '';

              }
              this._init();
          });
  }


    createdPost(post) {
      this.currentTodo.postId = post.id;
      this.currentPost = post;
      this.showPost = true;
  }

    getTodo() {
     
          const withPost = true;
          this.clientTodoService.getTodoTableData(this.user, this.org, this.currentTodoId, withPost)
              .subscribe(response => {
                  this.currentTodo = response.toDosList[0];
                  this.attachments = response.toDosList[0].documents;
                  this.isStatusDone = this.currentTodo.status.toLowerCase() === 'done' ? true : false;
                  if (response.post) {
                      this.createdPost(response.post);
                  } else {
                      this.showPost = true;
                  }
                  this.loadingService.triggerLoadingEvent(false);
              }, error => {
  
                  const message = error.message || `Failed To Get ToDo's`;
                  this.toastService.pop(TOAST_TYPE.error, message);
                  this.loadingService.triggerLoadingEvent(false);
              });
      }

      markAsDone(type){
        let obj = {};
        this.currentTodo.status = (this.currentTodo.status  && this.currentTodo.status.toLowerCase() == 'assigned') ? 'Done' : 'Assigned';
            obj['id'] = this.currentTodo.id;
            obj['action'] = 'singleUpdate';
            obj['actedOn'] = 'status';
            obj['value'] = this.currentTodo.status;
            obj['ids'] = [];
             this.loader=true;
            this.todoService.updateFirmTodoStatus(this.org, this.user, obj)
            .subscribe(response => {
              // this.currentTodo = response;
              if(type == 'status') {
                this.isStatusDone = this.currentTodo.status.toLowerCase() === 'done' ? true : false;
                if (this.isStatusDone) {
                  this.toastService.pop(TOAST_TYPE.success, 'Status Marked As Done');
                  this.loader=false;
                } else {
                  this.toastService.pop(TOAST_TYPE.success, 'Status Moved To Assigned');
                  this.loader=false;
                }
              } else {
                this.toastService.pop(TOAST_TYPE.success, 'Updated Successfully');
                this.loader=false;
              }
            }, error => {
              const message = error.message || 'Failed To preform action';
              this.toastService.pop(TOAST_TYPE.error, message);
              this.loadingService.triggerLoadingEvent(false);
            });
      }

      
}